<template>
  <div class="gallery_wrap">
    <div class="Gallery_wrap">
   <div class="container">
    <template v-if="get_gallery_list">
       <div class="grid">
    <template v-for="(item,index) in get_gallery_list.data">
    <div :key="item.id"  :class="['item', (index%2==0 ? 'item--large' : '') , (index%3==0 ? 'item--medium' : '') , (index%10==1 ? 'item--full' : '') ]" :style="`background-image:url('${item.file}')`">
        <a :href="item.file" data-lightbox="homePortfolio"></a>
      <div class="item__details">
        {{item.title}}
      </div>
    </div>
    </template>
  </div>
    </template>
    <template v-else>
      <div class="no_gallery">
        <img src="~@/assets/no_gallery.svg" alt="">
        <p>No Images Added !!</p>
      </div>
    </template>
   </div>
 <!-- <b-notification :closable="false">
            <b-loading :is-full-page="isFullPage" v-model="isLoading" :can-cancel="false"></b-loading>
</b-notification> -->
</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "galleryApp",
      data(){
          return{
            list_gallery_sub:{},
            isLoading: true,
             isFullPage: true,
          }
        },
        computed:{
            ...mapGetters({ 
                get_gallery_list:'get_gallery_list'
            })
        },
         methods: {
           ...mapActions({
                gallery_api:'gallery_api'
            }),
         },
        mounted(){
           this.gallery_api();
          document.body.classList.add('Gallery_wraps');
        },
    destroyed(){
      document.body.classList.remove('Gallery_wraps');
    }
};
</script>

<style lang="scss">
.no_gallery{
  min-height: 80vh;
  // text-align: center;
  padding: 50px 0px;
  img{
    height: 400px;
  }
  p{
    color: black;
    font-size: 15px;
    font-weight: 500;
    padding-top: 20px;
  }
}
.Gallery_wraps{
    min-height: 100vh;
    // background-image: url('~@/assets/bg_amber.png');
    background-size: cover;
    background-position: center center;
    position: relative;
.notification{
  background-color: transparent !important;  
}
}

</style>
<style lang="scss" scoped>
.Gallery_wrap{
    position: relative;
    z-index: 8;
    padding-top: 60px;
    padding-bottom: 50px;
}
.grid {
  display: grid;
  grid-gap: 30px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-auto-rows: 150px;
  grid-auto-flow: row dense;
}

.item {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  box-sizing: border-box;
  background: #0c9a9a;
  color: #fff;
  grid-column-start: auto;
  grid-row-start: auto;
  color: #fff;
  background:  url('https://images.unsplash.com/photo-1470124182917-cc6e71b22ecc?dpr=2&auto=format&fit=crop&w=1500&h=1000&q=80&cs=tinysrgb&crop=');
  background-size: cover;
  background-position: center;
  box-shadow: -2px 2px 10px 0px rgba(#444, 0.4);
  transition: transform 0.3s ease-in-out;
  cursor: pointer;
  counter-increment: item-counter;
  a{
    height: 100%;
    width: 100%;
    position: relative;
    z-index: 2;
  }
  
  &:nth-of-type(3n) {
    background-image: url('https://images.unsplash.com/photo-1422255198496-21531f12a6e8?dpr=2&auto=format&fit=crop&w=1500&h=996&q=80&cs=tinysrgb&crop=');
  }
  
  &:nth-of-type(4n) {
    background-image: url('https://images.unsplash.com/photo-1490914327627-9fe8d52f4d90?dpr=2&auto=format&fit=crop&w=1500&h=2250&q=80&cs=tinysrgb&crop=');
  }
  
  &:nth-of-type(5n) {
    background-image: url('https://images.unsplash.com/photo-1476097297040-79e9e1603142?dpr=2&auto=format&fit=crop&w=1500&h=1000&q=80&cs=tinysrgb&crop=');
  }
  
  &:nth-of-type(6n) {
    background-image: url('https://images.unsplash.com/photo-1464652149449-f3b8538144aa?dpr=2&auto=format&fit=crop&w=1500&h=1000&q=80&cs=tinysrgb&crop=');
  }
  
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.3;
    transition: opacity 0.3s ease-in-out;
  }
  
  &:hover {
    transform: scale(1.05);
    
    &:after {
      opacity: 0;
    }
  }

  &--medium {
    grid-row-end: span 2;
  }

  &--large {
    grid-row-end: span 3;
  }

  &--full {
    grid-column-end: auto;

    @media screen and (min-width: 768px) {
      grid-column: 1/-1;
      grid-row-end: span 2;
    }
  }
  
  &__details {
    position: relative;
    z-index: 1;
    padding: 10px;
    color: #444;
    font-weight: 500;
    background: #fff;
    text-transform: lowercase;
    letter-spacing: 1px;
    color: #828282;
    
    &:before {
      content: counter(item-counter);
      font-weight: bold;
      font-size: 1.1rem;
      padding-right: 0.5em;
      color: #444;
    }
  }
}
</style>
